import { Loader } from '@ur-solutions/react-components'
import type { ButtonProps } from '@/components_deprecated'
import { Button } from '@/components_deprecated'
import { PermissionsRequired } from '@/containers/permission-containers'
import type { SalaryWorkTimeNode } from '@/modules/companies'
import type { TerminalEntryNode } from '@/modules/terminal'
import { useTerminalEntriesMutations } from '@/modules/terminal'
import type { UserNode } from '@/modules/users'
import React from 'react'
import styled from 'styled-components'
import { PERMISSIONS } from '@/utils/permissions'

interface StyledButtonProps extends ButtonProps {
  $checkIn: boolean
  $loading: boolean
}
const StyledButton = styled(Button)<StyledButtonProps>`
  background-color: ${props =>
    props.$checkIn
      ? props.theme.colors.secondary
      : props.theme.colors.activitiesRed};

  color: white;
  font-size: 32px;
  font-weight: 900;
  text-decoration: none;
  border-radius: 50%;
  width: 80px !important;
  height: 80px !important;
  padding: 0;

  font-family: 'Font Awesome 6 Pro';

  &::before {
    content: ${props => (props.$checkIn ? '"\\f04b"' : '"\\f04d"')};
    ${props => props.$loading && 'margin-left: 0.1rem;'}
    position: relative;
    left: calc(50% - 14px);

    ${props => props.$loading && 'content: "";'}
  }
`

interface CheckInOutTerminalProps {
  user: UserNode
  latestEntry: TerminalEntryNode | null
  lastCheckIn: Date
  isWorking: boolean
  isOnNetwork: boolean
  salaryWorkTime: Pick<
    SalaryWorkTimeNode,
    'dailyWorkLimit' | 'pauseDuration'
  > | null
  loading: boolean
}

export const CheckInOutTerminal: React.FC<CheckInOutTerminalProps> = ({
  user,
  latestEntry,
  lastCheckIn,
  isWorking,
  isOnNetwork,
  salaryWorkTime,
  loading,
}) => {
  const mutations = useTerminalEntriesMutations(
    latestEntry,
    lastCheckIn,
    user.id,
    salaryWorkTime
  )
  const anyLoading = loading || mutations.loading
  const isDisabled = anyLoading

  return (
    <>
      {isOnNetwork ? (
        loading ? (
          <StyledButton $loading={true} $checkIn={false} disabled>
            <Loader.Spinner size={36} thickness={2} />
          </StyledButton>
        ) : isWorking ? (
          <PermissionsRequired
            permissions={PERMISSIONS.timesheets.change.checkinout}
          >
            <StyledButton
              $checkIn={false}
              $loading={anyLoading}
              disabled={isDisabled}
              onClick={mutations.handleCheckOut}
            >
              {anyLoading && <Loader.Spinner size={36} thickness={2} />}
            </StyledButton>
          </PermissionsRequired>
        ) : (
          <PermissionsRequired
            permissions={PERMISSIONS.timesheets.add.checkinout}
          >
            <StyledButton
              $checkIn
              $loading={anyLoading}
              disabled={isDisabled}
              onClick={mutations.handleCheckIn}
            >
              {anyLoading && <Loader.Spinner size={36} thickness={2} />}
            </StyledButton>
          </PermissionsRequired>
        )
      ) : (
        <StyledButton disabled $loading={anyLoading} $checkIn />
      )}
    </>
  )
}
